import React from "react";
import styles from "./PageHeader.module.scss";
import {SidebarContainer} from "./layout/SidebarContainer";

export const PageHeader: React.FC<{sidebar?:React.ReactNode|null}> = ({children,sidebar}) =>
    <SidebarContainer sidebar={sidebar}>
        <div className={styles.container}>{children}</div>
    </SidebarContainer>